import React from 'react'

const Events = (props) => {
  const {events} = props;
  let count = -1;
  let list;
  if (events.length > 0) {
    list = events.map(item =>{
      count++;
      console.log(item)
      return (
        <div key={count} className="card mx-5 mb-3">
          <div className="card-header">
          <h3>{item.fields.titulo}</h3>
          </div> 
          <div className="card-body event-info">
            <h5>{item.fields.descripcion.content[0].content[0].value}</h5>
              <iframe className="pdf" title={count} src={item.fields.archivo.fields.file.url}> </iframe>
            <div className="card-footer">
              <a className="noColor" target="_blank"  rel="noopener noreferrer" 
              href={item.fields.archivo.fields.file.url} 
              download={item.fields.titulo}><b>Descargar {item.fields.titulo}</b></a>
            </div>
          </div>
        </div>
        )
    })

  } else{
    list = <h3>Aún no hay eventos disponibles</h3>
  }

    return (
      <div>
        <h1>Eventos</h1>
        {list}
      </div>
       
        );
      }
export default Events;